module.exports = __webpack_public_path__ + "img/img_2.40f0e2bc.png";